export default (value) =>{
    return value ? 'Si':'No'
    
}

